import React, { useState, useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Row, Col, Card, CardBody, Form, Spinner } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { postRequestForm, postRequest } from "../../components/Common/Utils.js";
import Lightbox from "react-image-lightbox";
import FileUpload from "components/Common/FileUpload.js";
import CategoryModal from "components/Modal/CategoryModal.js";
import ProductModal from "components/Modal/ProductModal.js";
export default function CreateBanner() {
  const location = useLocation();
  const [bannerData, setBannerData] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [CategoryModel, setCategoryModel] = useState(false);
  const [ProductModel, setProductModel] = useState(false);

  const [CategoryallData, setCategoryallData] = useState({
    Image: "",
    Text: null,
    typeId: "",
    show: false,
  });

  const [startLoader, setStartLoader] = useState(false);
  let history = useHistory();

  const { id } = useParams();

  useEffect(() => {
    if (!selectedImage) return;
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(selectedImage);
  }, [selectedImage]);

  const showLightBox = (previewImage) => {
    setPreviewImage(previewImage);
    setOpenLightBox(true);
  };

  const Createbanner = async (e) => {
    e.preventDefault();

    setStartLoader(true);
    setLoading(true);

    const formData = new FormData();
    const selectedImageForm = new FormData();
    selectedImageForm.append("image", selectedImage);
    const selectedImageRes = await postRequestForm(
      "image/img/upload",
      selectedImageForm
    );
    setStartLoader(false);

    formData.append("title", bannerData.title);
    formData.append("description", bannerData.description);
    formData.append("type", bannerData.type);
    formData.append("typeId", bannerData.typeId);

    if (selectedImageRes?.data?.url) {
      formData.append("image", selectedImageRes.data.url);
    } else {
      console.error("Image URL not found in the response.");
    }

    const response = await postRequestForm("banner/add", formData);
    setLoading(false);

    if (response.status) {
      toast.success(response.message);
      setTimeout(() => {
        history.goBack();
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const updateValue = (index, value) => {
    const list = { ...bannerData };
    list[index] = value;
    setBannerData(list);
  };

  const closeModalCategory = () => {
    setCategoryModel(false);
  };

  const selectCategoryRow = (item) => {
    console.log({ item });
    setCategoryallData({
      Image: item?.image,
      Title: item?.title,
      typeId: item?._id,
      show: true,
    });
    updateValue("typeId", item?._id);
    setProductModel(false);
  };

  const toggleCategoryModel = () => {
    setProductModel(!CategoryModel);
  };

  // product modal logic

  const closeModalProduct = () => {
    setProductModel(false);
  };

  const selectProductRow = (item) => {
    console.log("product", { item });
    setCategoryallData({
      Image: item?.image || item?.images[0],
      Title: item?.title || item?.name,
      typeId: item?._id,
      show: true,
    });
    updateValue("typeId", item?._id);
    setProductModel(false);
  };

  const toggleProductModel = () => {
    setProductModel(!ProductModel);
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>Banner Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">Banner</li>:{" "}
              <li className="breadcrumb-item">Create Banner</li>
            </ol>
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg={12}>
          <Card>
            {loading ? (
              <CardBody style={{ height: "100px" }}>
                <Spinner
                  color="info"
                  style={{
                    height: "4rem",
                    width: "4rem",
                    position: "absolute",
                    left: "50%",
                  }}
                >
                  Loading...
                </Spinner>
              </CardBody>
            ) : (
              <CardBody>
                <h4 className="card-title"> Create Banner</h4>

                <Form onSubmit={Createbanner}>
                  <Row>
                    <Col lg={12} className="ms-lg-auto">
                      <div className="mt-5 mt-lg-4">
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Title
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) =>
                                updateValue("title", e.target.value)
                              }
                              value={bannerData?.title}
                              name="tags"
                              className="form-control"
                              required
                            />
                          </div>
                        </div>
                       

                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Type
                          </label>
                          <div className="col-sm-6">
                            <select
                              onChange={(e) =>
                                updateValue("type", e.target.value)
                              }
                              value={bannerData?.type}
                              name="type"
                              className="form-select"
                            >
                              <option value="category">Category</option>
                              <option value="product">Product</option>
                              <option value="link">Link</option>
                            </select>
                          </div>
                        </div>

                        {bannerData?.type == "category" && (
                          <div className="row mb-4">
                            <label className="col-sm-3 col-form-label">
                              Select Category
                            </label>

                            <div
                              className="col-sm-6"
                              onClick={() => {
                                toggleCategoryModel();
                              }}
                            >
                              {CategoryallData.show ? (
                                <div class="input-group">
                                  <button
                                    class="btn"
                                    style={{
                                      border: "1px solid #ced4da",
                                      background: "#f08d63",
                                      color: "#ffff",
                                    }}
                                    type="button"
                                    id="chooseCategoryBtn"
                                    onclick={() => toggleCategoryModel()}
                                  >
                                    Choose Category
                                  </button>
                                  <div
                                    style={{
                                      border: "1px solid #ced4da",
                                      width: "16px",
                                    }}
                                  ></div>
                                  <img
                                    src={CategoryallData?.Image}
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      border: "1px solid #ced4da",
                                      borderRight: "none",
                                      borderLeft: "none",
                                    }}
                                  ></img>
                                  <input
                                    type="text"
                                    style={{ borderLeft: "none" }}
                                    class="form-control"
                                    readonly
                                    value={CategoryallData?.Title}
                                    id="selectedCategory"
                                    placeholder="No Category chosen"
                                  />
                                </div>
                              ) : (
                                <div class="input-group">
                                  <button
                                    class="btn"
                                    style={{
                                      border: "1px solid #ced4da",
                                      background: "#f08d63",
                                      color: "#ffff",
                                    }}
                                    type="button"
                                    id="chooseCategoryBtn"
                                    onclick={() => toggleCategoryModel()}
                                  >
                                    Choose Category
                                  </button>
                                  <input
                                    type="text"
                                    class="form-control"
                                    readonly
                                    id="selectedCategory"
                                    placeholder="No Category chosen"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        {bannerData?.type == "link" && (
                          <div className="row mb-4">
                            <label className="col-sm-3 col-form-label">
                              Link
                            </label>
                            <div className="col-sm-6">
                              <input
                                type="text"
                                onChange={(e) =>
                                  updateValue("typeId", e.target.value)
                                }
                                value={bannerData?.typeId}
                                name="typeId"
                                className="form-control"
                                required
                              />
                            </div>
                          </div>
                        )}

                        {bannerData?.type == "product" && (
                          <div className="row mb-4">
                            <label className="col-sm-3 col-form-label">
                              Select Product
                            </label>

                            <div
                              className="col-sm-6"
                              onClick={() => {
                                toggleProductModel();
                              }}
                            >
                              {CategoryallData.show ? (
                                <div class="input-group">
                                  <button
                                    class="btn"
                                    style={{
                                      border: "1px solid #ced4da",
                                      background: "#f08d63",
                                      color: "#ffff",
                                    }}
                                    type="button"
                                    id="chooseProductBtn"
                                    onclick={() => toggleProductModel()}
                                  >
                                    Choose Product
                                  </button>
                                  <div
                                    style={{
                                      border: "1px solid #ced4da",
                                      width: "16px",
                                    }}
                                  ></div>
                                  <img
                                    src={CategoryallData?.Image}
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      border: "1px solid #ced4da",
                                      borderRight: "none",
                                      borderLeft: "none",
                                    }}
                                  ></img>
                                  <input
                                    type="text"
                                    style={{ borderLeft: "none" }}
                                    class="form-control"
                                    readonly
                                    value={CategoryallData?.Title}
                                    id="selectedProduct"
                                    placeholder="No Product chosen"
                                  />
                                </div>
                              ) : (
                                <div class="input-group">
                                  <button
                                    class="btn"
                                    style={{
                                      border: "1px solid #ced4da",
                                      background: "#f08d63",
                                      color: "#ffff",
                                    }}
                                    type="button"
                                    id="chooseProductBtn"
                                    onclick={() => toggleProductModel()}
                                  >
                                    Choose Product
                                  </button>
                                  <input
                                    type="text"
                                    class="form-control"
                                    readonly
                                    id="selectedProduct"
                                    placeholder="No Product chosen"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        <div className="row mb-4">
                          <label
                            htmlFor="horizontal-password-input"
                            className="col-sm-3 col-form-label"
                          >
                            Image
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="file"
                              onChange={(e) =>
                                setSelectedImage(e.target.files[0])
                              }
                              required
                              name="mediaUrl"
                              className="form-control"
                              id="horizontal-password-input"
                            />
                            <br />
                            {previewImage && (
                              <img
                                src={previewImage}
                                onClick={() => showLightBox(previewImage)}
                                style={{ width: "100px", height: "100px" }}
                              />
                            )}
                          </div>
                        </div>

                        <div className="mt-5 mt-lg-4">
                          <div className="row justify-content-end">
                            <div className="col-sm-9">
                              <div>
                                <button
                                  type="submit"
                                  className="btn btn-primary w-md"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            )}
          </Card>
        </Col>
      </Row>
      {/* {openLightbox && (
        <Lightbox
          mainSrc={previewImage}
          onCloseRequest={() => setOpenLightBox(false)}
        />
      )} */}
      <CategoryModal
        show={CategoryModel}
        closeModal={closeModalCategory}
        selectRow={selectCategoryRow}
      />

      <ProductModal
        show={ProductModel}
        closeModal={closeModalProduct}
        selectRow={selectProductRow}
      />
      <FileUpload message="File Uploading" status={startLoader} />
    </React.Fragment>
  );
}
